/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_First_LeadInputs */

const en_us2_draft_first_lead = /** @type {(inputs: Draft_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Swap or take out what doesn't fit; nothing starts until you confirm.`)
};

const pt_br2_draft_first_lead = /** @type {(inputs: Draft_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troque ou tire o que não fizer sentido; nada começa até você confirmar.`)
};

const es_419_draft_first_lead = /** @type {(inputs: Draft_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia o quita lo que no te sirva; nada empieza hasta que confirmes.`)
};

const pt_pt2_draft_first_lead = /** @type {(inputs: Draft_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Troca ou tira o que não fizer sentido; nada começa até confirmares.`)
};

const fr_fr2_draft_first_lead = /** @type {(inputs: Draft_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplace ou retire ce qui ne te convient pas ; rien ne commence avant ta confirmation.`)
};

const de_de2_draft_first_lead = /** @type {(inputs: Draft_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tausche oder entferne, was nicht passt; nichts startet, bevor du bestätigst.`)
};

const it_it2_draft_first_lead = /** @type {(inputs: Draft_First_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambia o togli quello che non va; non parte nulla finché non confermi.`)
};

/**
* | output |
* | --- |
* | "Swap or take out what doesn't fit; nothing starts until you confirm." |
*
* @param {Draft_First_LeadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_first_lead = /** @type {((inputs?: Draft_First_LeadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_First_LeadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_first_lead(inputs)
	if (locale === "es-419") return es_419_draft_first_lead(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_first_lead(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_first_lead(inputs)
	if (locale === "de-DE") return de_de2_draft_first_lead(inputs)
	if (locale === "it-IT") return it_it2_draft_first_lead(inputs)
	return en_us2_draft_first_lead(inputs)
});
export { draft_first_lead as "draft.first_lead" }